const customFrenchMessages = {
  ra: {
    configurable: {
      customize: 'Personalizar',
    },
    auth: {
      auth_check_error: 'Por favor, inicia sesión para continuar',
      logout: 'Cerrar sesión',
      password: 'Contraseña',
      sign_in: 'Iniciar sesión',
      sign_in_error: 'Falló la autenticación, inténtalo de nuevo',
      user_menu: 'Perfil',
      username: 'Nombre de usuario',
    },
    action: {
      add_filter: 'Agregar filtro',
      apply: 'Aplicar',
      back: 'Volver',
      cancel: 'Cancelar',
      clear_input_value: 'Limpiar valor',
      clone: 'Clonar',
      close: 'Cerrar',
      create: 'Crear',
      delete: 'Eliminar',
      edit: 'Editar',
      export: 'Exportar',
      list: 'Lista',
      refresh: 'Actualizar',
      remove: 'Eliminar',
      remove_filter: 'Eliminar filtro',
      save: 'Guardar',
      search: 'Buscar',
      show: 'Mostrar',
      sort: 'Ordenar',
      undo: 'Deshacer',
      expand: 'Expandir',
      close_menu: 'Cerrar menú',
      open_menu: 'Abrir menú',
      toggle_theme: 'Cambiar tema',
      add: 'Agregar',
    },
    boolean: {
      true: 'Sí',
      false: 'No',
    },
    page: {
      create: 'Crear %{name}',
      dashboard: 'Panel de control',
      edit: '%{name} #%{id}',
      error: 'Algo salió mal',
      list: '%{name}',
      loading: 'Cargando',
      not_found: 'No encontrado',
      show: '%{name} #%{id}',
      page_range_info: '{from}–{to} de {count}',
      range_info: '{from}–{to} de {count}',
      empty: 'Página Vacia',
    },
    input: {
      file: {
        upload_several:
          'Arrastra algunos archivos para subir o haz clic para seleccionar uno.',
        upload_single:
          'Arrastra un archivo para subir o haz clic para seleccionarlo.',
      },
      image: {
        upload_several:
          'Arrastra algunas imágenes para subir o haz clic para seleccionar una.',
        upload_single:
          'Arrastra una imagen para subir o haz clic para seleccionarla.',
      },
      references: {
        all_missing: 'No se pueden encontrar los datos de referencia.',
        many_missing:
          'Al menos una de las referencias asociadas ya no está disponible.',
        single_missing: 'La referencia asociada ya no está disponible.',
      },
    },
    message: {
      about: 'Acerca de',
      are_you_sure: '¿Estás seguro?',
      bulk_delete_content:
        '¿Estás seguro de que deseas eliminar este %{name}? |||| ¿Estás seguro de que deseas eliminar estos %{smart_count} elementos?',
      bulk_delete_title:
        'Eliminar %{name} |||| Eliminar %{smart_count} %{name}',
      delete_content: '¿Estás seguro de que deseas eliminar este elemento?',
      delete_title: 'Eliminar %{name} #%{id}',
      details: 'Detalles',
      error: 'Ocurrió un error y tu solicitud no pudo completarse.',
      invalid_form:
        'El formulario no es válido. Por favor, verifica los errores.',
      loading: 'La página está cargando, por favor espera.',
      no: 'No',
      not_found:
        'O ingresaste una URL incorrecta o seguiste un enlace incorrecto.',
      yes: 'Sí',
    },
    navigation: {
      no_results: 'No se encontraron resultados',
      page_rows_per_page: 'Filas por página',
      next: 'Siguiente',
      prev: 'Anterior',
      skip_nav: 'Saltar al contenido',
      page_range_info: '{from}–{to} de {count}',
      range_info: '{from}–{to} de {count}',
    },
    notification: {
      http_error: 'Error del servidor',
      canceled: 'Acción cancelada',
      created: 'Elemento creado correctamente',
      deleted: 'Elemento eliminado correctamente',
      updated: 'Elemento actualizado correctamente',
      not_authorized: 'No tienes permisos para acceder a este recurso',
    },
    validation: {
      email: 'Debe ser un correo electrónico válido',
      maxLength: 'Debe tener %{max} caracteres o menos',
      maxValue: 'Debe ser %{max} o menos',
      minLength: 'Debe tener al menos %{min} caracteres',
      minValue: 'Debe ser %{min} o más',
      number: 'Debe ser un número',
      oneOf: 'Debe ser uno de: %{options}',
      regex: 'Debe coincidir con un formato específico',
      required: 'Requerido',
    },
  },
  surveys: {
    language: {
      es: 'Español',
      en: 'Inglés',
      it: 'Italiano',
      fr: 'Frances',
    },
    resources: {
      campaign: 'Campagne',
      campaigns: 'Campagnes',
      user: 'Utilisateur',
      users: 'Utilisateurs',
      question: 'Question',
      questions: 'Questions',
      response: 'Répondre',
      responses: 'Réponses',
      coreg: 'Coreg',
      coregs: 'Coregs',
      thematics: 'Thematics',
      thematic: 'Thematic',
      wscampaign: 'WS Campaña',
      wscampaigns: 'WS Campañas',
      dashboard: 'Dashboard',
      delivery: 'Delivery',
      deliveries: 'Deliveries',
    },
    actions: {
      show_question: 'Afficher la question',
      edit_question: 'Modifier la question',
      add_response: 'Ajouter une réponse',
      new_coregs: 'Ajouter Coreg',
      create_coregs: 'Créer Coreg',
      new_thematics: 'Ajouter thématique',
      create_thematics: 'Créer thématique',
      new_wscampaign: 'Ajouter campagne WS',
      create_wscampaign: 'Créer campagne WS',
    },
    dashboard: {
      subtitle:
        'Gérez campagnes, questions et utilisateurs depuis un panneau centralisé.',
      quick_actions: 'Accès rapides',
    },
    menu: {
      management: 'Contenu',
      integrations: 'Intégrations',
      audience: 'Audience',
    },
    campaigns: {
      tab_summary: 'Résumé',
      tab_flow: 'Parcours des questions',
      tab_questions: 'Questions',
      tab_summary_form: 'Informations générales',
      flow_title: 'Parcours de la campagne',
      view_cards: 'Vue cartes',
      view_table: 'Vue tableau',
      response_type: 'Type de réponse',
      question_count: '%{count} questions',
      first_question: 'Première question',
      no_questions_title: 'Aucune question associée',
      no_questions_hint:
        'Cette campagne ne collecte que le formulaire initial et redirige vers le thanks.',
      no_questions_short: 'Formulaire seul',
      questions_hint:
        "Ajoutez les questions racines dans l'ordre. Laissez vide si pas d'enquête.",
      step_of: 'Question %{current} sur %{total}',
      add_question: 'Ajouter une question',
      select_question: 'Sélectionner une question…',
      no_more_questions: 'Plus de questions disponibles',
      questions_order: 'Ordre du parcours',
      no_questions_in_form: 'Aucune question sélectionnée.',
    },
    common: {
      status: 'Estado',
      active: 'Actif',
      desactive: 'Baja',
      vip: 'Vip',
      standard: 'Standard',
      identify: 'Identifiant',
      name: 'Name',
      registered: 'Registered',
      registration_date: 'Registration date',
      origin: 'Origine',
      boolean: {
        yes: 'Yes',
        no: 'No',
      },
    },
    messages: {
      welcome: 'Welcome to the administration',
      update_success: 'The update finished successfully',
      update_failure: 'An error occurred during update',
      user_deactivated_by_admin: 'User deactivated by an administrator',
      data_loading: 'Loading data ...',
      data_error: 'Error loading data',
      chart_data_loading: 'Loading chart data ...',
      chart_data_error: 'Error loading chart data',
      forgot_password: 'Forgot password?',
      reset_password: 'Reset password',
      reset_password_text:
        "Enter the email associated with your account and we'll send an email with instructions to reset your password.",
      confirm_password: 'Confirm password',
      create_password: 'Create new password',
      create_password_text: 'Please enter a new password',
      change_password: 'Change password',
      change_password_success: 'Password changed successfully',
      change_password_error: 'Error on reset password',
      change_password_link_error: 'Link not valid',
      forgot_password_success:
        'An email will be sent with the instructions to reset your password',
      forgot_password_error: 'Error requesting the password change',
      send_instructions: 'Send instructions',
      exceptions: {
        ResourceUrlExistException:
          'Une ressource avec cette URL existe déjà (%{url})',
      },
    },
    validations: {
      confirmPassword: 'Password must be the same as the confirm password',
    },
  },
}

export default customFrenchMessages
